import { RpcService } from 'rpc';

export declare interface Perms {
	[key: string]: boolean;
}

export declare interface UserInfoService extends RpcService {
	roles(): Promise<Perms>;
}

export const svc: UserInfoService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@user-info.rpc`,

	services: {
		roles: {
			cacheable: true,
			cacheLifetime: 24,
			parameters: []
		}
	}
}) as UserInfoService;

export default svc;
